// src/admin_module/services/planService.js
import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

export const fetchAllPlans = () =>
  api.get("/admin/subscription-plans/all_plans");

export const fetchActivePlans = () =>
  api.get("/admin/subscription-plans/active");

export const fetchInActivePlans = () =>
  api.get("/admin/subscription-plans/de_active_plans");

export const createPlan = (data) =>
  api.post("/admin/subscription-plans/createPlan", data);

export const deactivatePlan = (planId) =>
  api.put(`/admin/subscription-plans/${planId}/deactivate`);

export const activatePlan = (planId) =>
  api.put(`/admin/subscription-plans/${planId}/activate`);
